export default "__VITE_ASSET__CEGGUUHN__"